export default class UserMenuController {
    static setup() {
        const toggleBtn = document.getElementById('userMenu');
        const menus = () => Array.from(document.querySelectorAll('.dropdown-menu-user'));

        // 1) Show the menu when #userMenu is clicked
        if (toggleBtn) {
            toggleBtn.addEventListener('click', () => {
                menus().forEach((menu) => menu.classList.remove('d-none'));
            });
        }

        // 2) Hide the menu when clicking outside of it
        document.addEventListener('mouseup', (e) => {
            menus().forEach((menu) => {
                if (menu !== e.target && !menu.contains(e.target)) {
                    menu.classList.add('d-none');
                }
            });
        });
    }
}
